import {CA_enableButton} from "./dom";
import { Constants } from "../data/constants";

export function CA_EnableModify() {
    const { eTree } = GlobalEnt;
    if (!eTree) {
        console.error("eTree is not loaded...");
        return;
    }

    const treeLoc = eTree.getSelectedTreeLocation();
    let enableSelected = false;

    if (treeLoc) {
        if ("notGroup" in window) enableSelected = eTree.getSelectedNode() != 1;
        else enableSelected = treeLoc.etype == Constants.TYPE_GROUP;
    }

    CA_enableButton("tree-button-remove", enableSelected);
    CA_enableButton("tree-button-edit", enableSelected);
    CA_enableButton("tree-button-cut", enableSelected);
}

export function treeIsVisible() {
    const treeContainer = document.querySelector('.tree-container');
    const contentContainer = document.querySelector('.content-container');
    const hasTreeCollapsed = contentContainer ? contentContainer.classList.contains('tree-collapsed') : false;
    return treeContainer && !hasTreeCollapsed;
}